"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const _1 = require("../.");
/**
 * Multiple rows input for entering longer paragraphs of text.
 */
const TextArea = ({ name, value, placeholder, mandatory, setValue, rows = 5, min, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("textarea", { className: (0, classnames_1.default)(classes.textArea, 'rfc-input'), name: name, rows: rows, placeholder: placeholder, onChange: e => setValue(name, e.target.value, mandatory, { touched: true, min }), value: value }));
};
const useStyles = (0, react_jss_1.createUseStyles)({
    textArea: {
        display: 'block',
        resize: 'vertical',
    },
});
exports.default = (0, _1.withFormControl)(TextArea);
